import { render, staticRenderFns } from "./ModalSucessoClientId.vue?vue&type=template&id=2c234dea&scoped=true"
import script from "./ModalSucessoClientId.vue?vue&type=script&lang=js"
export * from "./ModalSucessoClientId.vue?vue&type=script&lang=js"
import style0 from "./ModalSucessoClientId.vue?vue&type=style&index=0&id=2c234dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c234dea",
  null
  
)

export default component.exports